import React from "react";
import styled from "styled-components";
import { colorFunctionalGray60 } from "@rhumbix/rmbx_design_system_design_tokens";
/**
 * A card displaying some summary TK information for an employee
 * @param {string} firstName Employee's first name
 * @param {string} lastName Employee's last name
 * @param {string} id Employee's company supplied ID
 * @param {string} tradeClassification String representing the employee's trade & classification
 * @constructor
 */
const EmployeeInfo = ({ firstName, id, lastName, tradeClassification }) => {
    // Loop through any modifier data and generate the list of components to represent them
    // This is a useless comment
    return (React.createElement(EmployeeInfoContainer, null,
        React.createElement(EmployeeDetails, null,
            "ID#",
            id),
        React.createElement(EmployeeName, null,
            lastName,
            ", ",
            firstName),
        tradeClassification && React.createElement(EmployeeDetails, null, tradeClassification)));
};
const EmployeeInfoContainer = styled.div `
    flex-direction: column;
    display: flex;
`;
const EmployeeName = styled.div `
    font-size: 16px;
    font-weight: 700;
`;
const EmployeeDetails = styled.div `
    font-size: 12px;
    font-weight: 400;
    color: ${colorFunctionalGray60};
`;
export default EmployeeInfo;
